module.exports = __webpack_public_path__ + "img/header-diamondJewelryColliers.c52c4f7.jpg";